// extracted by mini-css-extract-plugin
export default {"infoTextFields":"InfoTextFields_infoTextFields__m99cN"};